<template>
  <v-select
    v-model="filtro"
    :items="asesores"
    outlined
    item-text="option"
    item-value="PERNR"
    label="Seleccionar Asesor / Zona"
    @input="$emit('changeSelectAsesor', filtro)"
  />
</template>

<script>
  /* eslint-disable vue/require-default-prop, vue/require-prop-types */
  export default {
    props: ['filtroPERNR', 'clientes'],
    data() {
      return {
        filtro: '',
      };
    },
    computed: {
      asesores() {
        const defaultOption = {
          option: 'Todos los asesores',
          PERNR: '',
        };
        const asesores = this.clientes.map((cliente) => {
          return {
            option: `${cliente.NAMEV} / ${cliente.BZIRK}`,
            PERNR: cliente.PERNR,
          };
        });

        asesores.sort((a, b) => a.PERNR - b.PERNR); // Ordenar de mayor a menor por PERNR

        return [defaultOption, ...asesores];
      },
    },
    watch: {
      filtroPERNR(newVal) {
        this.filtro = newVal;
      },
    },
  };
</script>

<style></style>
